<div class="ckeditor"><textarea :id="id" :name="name" :value="modelValue" :types="types" :config="config" :disabled="readOnlyMode"></textarea></div>